import React from 'react';
import AnnourFooter from '../BeforeLoginPages/AnnourFooter';

const GermanLangSupportCourse = () => {
  return (
    <div className="min-h-screen pt-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-5xl mx-auto bg-white/90 backdrop-blur-sm p-8 shadow-2xl rounded-xl border border-blue-100">
        <h1 className="text-3xl md:text-4xl font-extrabold text-main mb-6 relative">
          <span className="relative inline-block">
            Sprachförderungskurse
            <div className="absolute bottom-0 left-0 w-full h-1 bg-blue-500 transform origin-left scale-x-100"></div>
          </span>
          <span className="block text-2xl md:text-3xl mt-2 text-cyan-800 font-semibold">
            in Kooperation mit dem Jugendamt Braunschweig
          </span>
        </h1>

        <p className="text-lg text-gray-700 mb-6 leading-relaxed">
          Seit 2017 bietet Annour e.V. in Zusammenarbeit mit dem
          Jugendamt Braunschweig spezielle Sprachförderungskurse für
          Schüler*innen der Klassen 1 bis 9 an.
        </p>

        <a
          href="https://www.braunschweig.de/vv/oe/V/51/index.php"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-700 text-white rounded-lg hover:bg-cyan-800 transition-colors duration-300 mb-6"
        >
          <span>Jugendamt Braunschweig Website</span>
          <span className="text-xl">↗️</span>
        </a>

        <div className="grid md:grid-cols-2 gap-8 mt-6">
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-6">
            <h2 className="text-2xl font-semibold text-cyan-900 mb-4 flex items-center">
              <span className="text-3xl mr-2">🗓</span>{' '}
              Unterrichtszeiten
            </h2>
            <ul className="space-y-3">
              <li className="flex items-center p-2 hover:bg-blue-50 rounded-lg transition-colors">
                <span className="text-xl mr-2">📅</span>
                <div>
                  <strong className="text-gray-800">Samstags:</strong>
                  <span className="text-cyan-700 ml-2">
                    15:45 – 17:15 Uhr
                  </span>
                </div>
              </li>
              <li className="flex items-center p-2 hover:bg-blue-50 rounded-lg transition-colors">
                <span className="text-xl mr-2">📅</span>
                <div>
                  <strong className="text-gray-800">
                    Mittwochs:
                  </strong>
                  <span className="text-cyan-700 ml-2">
                    17:00 – 18:30 Uhr
                  </span>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-6">
            <h2 className="text-2xl font-semibold text-cyan-900 mb-4 flex items-center">
              <span className="text-3xl mr-2">📲</span> Anmeldung
            </h2>
            <p className="text-lg text-gray-700 mb-4">
              Bitte melden Sie sich per WhatsApp an:
            </p>
            <a
              href="tel:004915259431515"
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300"
            >
              <span className="text-xl">📱</span>
              <span className="font-semibold">
                +49 152 594 315 15
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <AnnourFooter />
      </div>
    </div>
  );
};

export default GermanLangSupportCourse;
